import { NgModule } from '@angular/core';
import { CarrierNamePipe } from './carrier-name.pipe';

@NgModule({
  declarations: [CarrierNamePipe],
  providers: [],
  imports: [],
  exports: [CarrierNamePipe],
})
export class CarrierNamePipeModule {}
